import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import LegalChatPage from "./pages/LegalChatPage";
import AdminPage from "./pages/AdminPage";
import AdminRoute from "./components/AdminRoute";
import PaymentConfirmationPage from "./pages/PaymentConfirmationPage";
import {
  PreLegalAvisoLegalPage,
  PreLegalTermsPage,
  PreLegalPrivacyPage,
} from "./pages/PreLegalLegalPages";
import LexWidget from "./components/LexWidget";
import "@/App.css";

const LEGAL_CHAT_PATH = "/chat";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage chatPath={LEGAL_CHAT_PATH} />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route
              path={LEGAL_CHAT_PATH}
              element={
                <ProtectedRoute>
                  <LegalChatPage />
                </ProtectedRoute>
              }
            />
            {/* Backwards-compat redirect from the old obfuscated URL */}
            <Route
              path="/legal-8d1gwmrixnd3gn7s"
              element={<Navigate to={LEGAL_CHAT_PATH} replace />}
            />
            <Route path="/prelegal/aviso-legal" element={<PreLegalAvisoLegalPage />} />
            <Route path="/prelegal/terminos" element={<PreLegalTermsPage />} />
            <Route path="/prelegal/privacidad" element={<PreLegalPrivacyPage />} />
            <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
            <Route
              path="/pago/confirmacion"
              element={
                <ProtectedRoute>
                  <PaymentConfirmationPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <LexWidget />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
